<!--
<div class="category" *ngFor="let cat of categories" (click)="toCategory(cat)" [ngClass]="{'active':cat==currentCategory}">
  {{cat}}
  <a (click)="router.navigateByUrl('image')" title="Remove this filter" *ngIf="cat==currentCategory">
    <div class="xbutton">X</div>
  </a>
</div><br>
-->
<div class="searchbox">
  <select (change)="toCategory($event.target.value)" class="search">
  <option *ngFor="let cat of categories" [value]="cat">{{cat}}</option>
  </select>

  <input type="text" class="search" [(ngModel)]="search" placeholder="suche" (keyup.enter)="apiService.setSearch(search, true)">
  <button id="searchbutton" class="search" (click)="apiService.setSearch(search, true)">Suche</button>
</div>
